export const getMobileNavBar = (state) => state.ui.mobile.mobileNav.navBar;